module.exports = __webpack_public_path__ + "c862e94cbef741d18838774587e3c49d.svg";